import { baseApi } from 'api/base';
import { fileApi } from 'api/file';
import { RegistryProductFile } from 'types/types';
import { FormBackend, Form } from '../types/types';
import { ViewFormType, FeedAdditivePdf } from './params';

const createCard = async (data: Form): Promise<string> => {
  const editedGMO = data.gmoList?.map((item) => ({
    ...item,
    id: null,
  }));

  const editedProducers = data.producerList.map((item) => ({
    ...item,
    id: null,
    resident: item.resident === 'true',
    locationList: item.locationList.map((placeItem) => ({
      ...placeItem,
      id: null,
      resident: placeItem.resident === 'true',
    })),
  }));

  const editedData: FormBackend = {
    entry: {
      requestDate: data.requestDate,
      requestRegNumber: data.requestRegNumber,
      requestRegDate: data.requestRegDate,
      requestMethod: data.requestMethod,
      erulRegNumber: data.erulRegNumber,
      erulRegDate: data.erulRegDate,
    },
    product: {
      ...data,
      id: undefined,
      uuid: undefined,
      protocolList: undefined,
      instructionList: undefined,
      entry: undefined,
      gmoList: editedGMO,
      producerList: editedProducers,
      vendorType: data.vendorType === 'true' ? 'DOMESTIC' : 'FOREIGN',
      animalSpeciesList: data.animalSpeciesList?.map((species) => ({ animalSpecies: species })),
    },
    productType: 'feed',
  };

  const res = await baseApi.post('/entry/create', editedData);

  return res.data.id;
};

const updateCard = async (data: Form): Promise<string> => {
  const editedGMO = data.gmoList?.map((item) => ({
    ...item,
    id: item.id ? item.id : null,
  }));

  const editedProducers = data.producerList.map((item) => ({
    ...item,
    id: item.id ? item.id : null,
    resident: item.resident === 'true',
    locationList: item.locationList.map((placeItem) => ({
      ...placeItem,
      resident: placeItem.resident === 'true',
    })),
  }));

  const editedData: FormBackend = {
    entry: {
      id: data.rootId,
      requestDate: data.requestDate,
      requestRegNumber: data.requestRegNumber,
      requestRegDate: data.requestRegDate,
      requestMethod: data.requestMethod,
      startValidityDate: data.startValidityDate,
      endValidityDate: data.endValidityDate,
      regNumber: data.regNumber,
      series: data.series,
      erulRegNumber: data.erulRegNumber,
      erulRegDate: data.erulRegDate,
    },
    product: {
      ...data,
      gmoList: editedGMO,
      producerList: editedProducers,
      vendorType: data.vendorType === 'true' ? 'DOMESTIC' : 'FOREIGN',
      animalSpeciesList: data.animalSpeciesList?.map((species) => ({ animalSpecies: species })),
    },
    productType: 'feed',
  };

  const res = await baseApi.post('/entry/update', editedData);

  return res.data.id;
};

const getCard = async (id: string): Promise<ViewFormType> => {
  const res = await baseApi.get(`/entry/${id}`);

  return res.data;
};

const deleteCard = async (id: string) => {
  await baseApi.delete(`/request/delete/${id}`);
};

const setInstruction = async (id: string, data: RegistryProductFile) => {
  await baseApi.post(`/entry/${id}/instruction`, data);
};

const removeInstruction = async (id: string, itemId: string) => {
  await baseApi.delete(`/entry/${id}/instruction/${itemId}`);
};

const getFeedAdditivePdf = async (data: FeedAdditivePdf) =>
  baseApi
    .post('/report/pdf/feed-additive', data, { responseType: 'blob' })
    .then(fileApi.downloadFile);

export const feedAdditiveApi = {
  createCard,
  updateCard,
  getCard,
  deleteCard,
  setInstruction,
  removeInstruction,
  getFeedAdditivePdf,
};
